import React, { FC, useCallback, useMemo } from 'react';
import { BankPageProductCardProps } from './types';
import { ProductCardsContent } from '../ProductCardsContent';
import { getBankPagePath } from 'utils/getBankPagePath';
import { useFeatureFlag } from '@raisin/cp-utils';

const BankPageProductCards: FC<BankPageProductCardProps> = (props) => {
  const { variation } = useFeatureFlag();
  const { locale, dbs } = props;
  const shouldUseBankSlugFallback = variation?.('b2CShouldUseBankSlugFallback', false);

  const genereateBankPage = useMemo(() => getBankPagePath(locale), [locale]);
  const onLinkGenerate = useCallback(
    (productId: string) =>
      genereateBankPage({
        productId,
        shouldUseBankSlugFallback,
        bankName: dbs[productId].deposit_taking_bank.name,
        bankSlug: dbs[productId].deposit_taking_bank.bank_slug,
      }),
    [genereateBankPage, dbs],
  );
  return <ProductCardsContent testId="BankPage" {...props} linkGenerator={onLinkGenerate} />;
};
export default BankPageProductCards;
